<template>
    <span class="superuser-menu">
        <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" color="deep-orange" class="mx-1">
                    <v-icon left>mdi-shield-account</v-icon>
                    Ver como: {{ etiquetaActual }}
                    <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item v-for="(info, perfil) in PERFILES" :key="perfil" @click="elegirPerfil(perfil)" link>
                    <v-list-item-icon>
                        <v-icon>{{ info.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        {{ info.label }}<span v-if="perfil !== 'secretaria'">…</span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-chip v-if="soloLectura" small color="deep-orange" text-color="white" class="mx-1 mt-2">
            <v-icon small left>mdi-eye</v-icon>
            Solo lectura
        </v-chip>

        <v-dialog v-model="dialog" max-width="520">
            <v-card>
                <v-card-title>Ver como {{ perfilElegido === 'medico' ? 'médico' : 'paciente' }}</v-card-title>
                <v-card-text>
                    <v-autocomplete
                        v-model="usuarioElegido"
                        :items="resultados"
                        :loading="buscando"
                        :search-input.sync="busqueda"
                        :item-text="textoUsuario"
                        return-object
                        no-filter
                        hide-no-data
                        clearable
                        autofocus
                        label="Buscar por nombre, apellido, DNI o email"
                        prepend-inner-icon="mdi-magnify"
                    >
                        <template v-slot:item="{ item }">
                            <v-list-item-content>
                                <v-list-item-title>{{ nombreCompleto(item) }}</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ item.dni ? 'DNI ' + item.dni + ' · ' : '' }}{{ item.email }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                    <p v-if="error" class="error--text mb-0">{{ error }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">Cancelar</v-btn>
                    <v-btn color="primary" :disabled="!usuarioElegido" @click="confirmar">Ver</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import { PERFILES, buscarUsuarios, nombreCompleto, verComo } from '@/services/superuser';

export default {
    name: 'SuperuserMenu',
    data() {
        return {
            PERFILES,
            dialog: false,
            perfilElegido: null,
            busqueda: '',
            resultados: [],
            usuarioElegido: null,
            buscando: false,
            error: '',
            timer: null
        };
    },
    computed: {
        viewAs() {
            return this.$store.state.view_as;
        },
        soloLectura() {
            return !!this.$store.getters.viewAsEmail;
        },
        etiquetaActual() {
            const v = this.viewAs;
            if (!v || v.perfil === 'secretaria' || !v.target) return PERFILES.secretaria.label;
            const prefijo = v.perfil === 'medico' ? 'Dr/a. ' : '';
            return prefijo + nombreCompleto(v.target);
        }
    },
    watch: {
        busqueda(valor) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.buscar(valor), 300);
        }
    },
    beforeDestroy() {
        clearTimeout(this.timer);
    },
    methods: {
        nombreCompleto,
        textoUsuario(item) {
            return nombreCompleto(item) + (item.dni ? ' (' + item.dni + ')' : '');
        },
        elegirPerfil(perfil) {
            if (perfil === 'secretaria') {
                verComo(this.$store, 'secretaria');
                return;
            }
            this.perfilElegido = perfil;
            this.usuarioElegido = null;
            this.resultados = [];
            this.error = '';
            this.dialog = true;
            this.buscar('');
        },
        async buscar(valor) {
            if (!this.dialog || !this.perfilElegido) return;
            // Evita re-buscar cuando el autocomplete muestra el texto del elegido
            if (this.usuarioElegido && valor === this.textoUsuario(this.usuarioElegido)) return;
            this.buscando = true;
            this.error = '';
            try {
                this.resultados = await buscarUsuarios(this.perfilElegido, valor || '');
            } catch (e) {
                this.resultados = [];
                this.error = 'No se pudo buscar usuarios';
            } finally {
                this.buscando = false;
            }
        },
        confirmar() {
            if (!this.usuarioElegido) return;
            this.dialog = false;
            verComo(this.$store, this.perfilElegido, this.usuarioElegido);
        }
    }
};
</script>

<style scoped>
.superuser-menu {
    display: inline-flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
</style>
